/* LEGACY LIST, DON'T ADD ANY NEW FLAGS IN THIS LIST */

import { getFlag } from 'hb-react/shared/utils/launchDarkly';

export default ({
  flagBraintree3DSecureSca,
  flagBulkAdminInvitations,
  flagCdUniversalTags,
  flagDuplicateAdmin,
  flagStanfordMessagingRequirements,
  testSomeFeatureFlag,
}) => ({
  flags: [
    'flagBraintree3DSecureSca',
    'flagBulkAdminInvitations',
    'flagCdUniversalTags',
    'flagCompaniesFacelift',
    'flagDuplicateAdmin',
    'flagGroupsHeaderFacelift',
    'flagStanfordMessagingRequirements',
    'testSomeFeatureFlag',
  ],
  values: {
    payments: {
      braintreeSca: getFlag({ flagBraintree3DSecureSca }),
    },
    messaging: {
      stanfordRequirements: getFlag({ flagStanfordMessagingRequirements }),
    },
    contentDiscovery: {
      universalTags: getFlag({ flagCdUniversalTags }),
    },
    testSomeFeatureFlag: getFlag({ testSomeFeatureFlag }),
    admins: {
      adminInvitationsBo: getFlag({ flagBulkAdminInvitations }),
      duplicateAdminBo: getFlag({ flagDuplicateAdmin }),
    },
  },
});
